import { IStepControl, Step } from '../../../domains/wizard';
import { observer } from 'mobx-react';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  stepControl: IStepControl;
  step: Step;
}

export const HeaderReview = observer((props: IProps) => {
  const { t } = useTranslation('', { keyPrefix: 'REVIEW_AND_SIGN_UP' });
  const { t: tCommon } = useTranslation('');
  const getIndex = useCallback(
    (step: Step) => props.stepControl.stepsMap.find(x => x.key === step)?.index ?? 0,
    [props.stepControl.stepsMap],
  );
  const setActiveStep = useCallback((step: Step) => props.stepControl.setActiveStep(step), [props.stepControl]);
  const index = useMemo(() => getIndex(props.step), [getIndex, props.step]);
  return (
    <div className="container-step-title-conf avoid-break">
      <h3>
        <span>{index + 1}</span>. <span>{tCommon(`TAB.${props.step}`)}</span>
      </h3>
      <button type="button" className="n2pc-btn-text step-edit-btn" onClick={() => setActiveStep(index)} data-html2canvas-ignore="true">
        {t('EDIT')}
      </button>
    </div>
  );
});
